'use strict';exports.__esModule = true;var createMultiPolygon = exports.createMultiPolygon = function createMultiPolygon(coordinates) {return {
    type: 'MultiPolygon',
    coordinates: coordinates };};


var createPolygon = exports.createPolygon = function createPolygon(coordinates) {return {
    type: 'Polygon',
    coordinates: coordinates };};


var createFeature = exports.createFeature = function createFeature(geometry) {return {
    type: 'Feature',
    geometry: geometry };};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MapContainer/geojson-helpers.js
// module id = 2948
// module chunks = 0